/* eslint-disable array-callback-return */
import React, { useState, useRef } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import Comprovante from './comprovante';
import ReactToPrint from 'react-to-print';

export const ModalDetails = ({
  buttonLabel,
  className,
  content,
  size,
  message,
}) => {
  const [modal, setModal] = useState(false);
  let componentRef = useRef();

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <div>
      <Button
        color='danger'
        onClick={() => toggle()}
        size={size}
        title={message}
      >
        {buttonLabel}
      </Button>
      <Modal
        isOpen={modal}
        toggle={() => toggle()}
        className={className}
        size='lg'
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            margin: '10px',
          }}
        >
          <ReactToPrint
            trigger={() => (
              <Button color='success' size='lg' style={{ width: '100%' }}>
                Imprimir
              </Button>
            )}
            content={() => componentRef}
          />
        </div>
        <ModalBody>
          <Comprovante
            ref={(el) => (componentRef = el)}
            content={content}
            information={{}}
          />
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={() => toggle()}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalDetails;
